import React from 'react'

const Objects = () => {
  return (
    <div>Objects</div>
  )
}

export default Objects